module.exports = __webpack_public_path__ + "img/logo_dark_min2.7593ec7f.png";